<mat-card class="mat-elevation-z4">
    <mat-card-content>
        <div class="alignment">
            <mat-icon>warning</mat-icon>
            <div class="spacer"></div>
            <div>
                {{'accessDenied.message' | translate}}
            </div>
        </div>
    </mat-card-content>
</mat-card>